module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_iterators.js
// module id = 149
// module chunks = 168707334958949